export const PROFILE_INITIALIZE = 'PAGE_PROFILE_INITIALIZE';
export const PROFILE_INPUT_CHANGE = 'PAGE_PROFILE_INPUT_CHANGE';
export const PROFILE_ADMIN_CHANGE = 'PAGE_PROFILE_ADMIN_CHANGE';

export function initialize() {
  return {
    type: PROFILE_INITIALIZE
  };
}

export function inputChange(field, newData) {
  return {
    type: PROFILE_INPUT_CHANGE,
    field,
    newData
  };
}

export function adminChange(isTeamAdmin) {
  return {
    type: PROFILE_ADMIN_CHANGE,
    isTeamAdmin
  };
}



// WEBPACK FOOTER //
// ./js/actions/page/Profile.js